/*
 * @Author: ChengQing
 * @Date: 2020-09-14 15:17:49
 * @Last Modified by: Liangli
 * @Last Modified time: 2022-01-10 17:31:44
 */
import React, { useState, useEffect } from "react";
import { Modal, Button, Select, Input, message, Spin, Collapse } from "antd";
import { connect } from "react-redux";
import { stationgisApi, stationflowchart } from '@api/newApi';
import publicApi from "@api/public";
import MyIcon from "../../../components/MyIcon";
import xsProcessImg from "../../../assets/gylct-imgs/process_01.jpg";
import lx_xt_ProcessImg from "../../../assets/gylct-imgs/lx-xt.jpg";
import "./style.scss";
import MediaComponent from "./components/media";
import ConfigItem from "./components/configItem";
import ConfigItemEdit from "./components/configItemEdit";
import StateBox from "./components/stateBox";
import classnames from 'classnames';
import VideoModal from "./components/VideoModal";
import infoJson from './info.json'
import right from "../../screen/view/right";

const qs = require("query-string");
const { Option } = Select;
const Pages = ({ history, userInfo, searchArgs, dispatch }) => {
  // 链接参数
  const [params, setParams] = useState(qs.parse(history.location.search));
  // 当前选中的工艺单元id
  const [currentConfig, setCurrentConfig] = useState("");
  // 厂站列表数据
  const [markers, setMarkers] = useState([]);
  // 进出水口展示累计瞬时信息
  const [showData, setAllShowData] = useState({
    CSLJLL: 0,
    JSLJLL: 0,
    CSSSLL: 0,
    JSSSLL: 0
  });
  // 进水口流量计详情
  const [jskLLLArr, setjskLLLArr] = useState([]);
  // 是否展示摄像头弹窗
  const [visible, setVisible] = useState(false);
  // 厂站id
  const [id, setId] = useState(null);
  const [name, setName] = useState(null);
  // 所有工艺单元的详情数据
  const [detailInfo, setDetailInfo] = useState({});
  // 是否展示参数配置弹窗
  const [configVisible, setConfigVisible] = useState(false);
  // 参数设置弹窗宽度
  const [modalWidth, setModalWidth] = useState(592);
  // 参数设置弹窗loading状态
  const [loading, setLoading] = useState(false);
  // 参数设置弹窗标题
  const [title, setTitle] = useState("参数设置");
  // 所有参数设置，选中的工艺单元项
  const [activeIdx, setActiveIdx] = useState(0);
  // 参数设置的所有数据
  const [commandsAll, setCommandsAll] = useState([]);
  // 参数设置弹窗》右侧展示数据
  const [rightDatas, setRightDatas] = useState([]);
  // 参数设置弹窗》右侧input的ref数据
  const [inputRef, setInputRef] = useState([]);



  /* *********************************图层及覆盖物的位置数据 b************************************** */
  // const [coverAndBgImgData, setCoverAndBgImgData] = useState({
  //   cls: '',
  //   imgUrl: xsProcessImg,
  //   stateBoxData: [
  //     {
  //       id: 'CSQ',
  //       name: '出水口',
  //       lineBox: 'right',
  //       style: {
  //         conHeight: '108px',
  //         left: '10%',
  //         top: '28.5%',
  //       },
  //       lineStyle: {
  //         width: '203px',
  //         right: '-203px'
  //       },
  //       show: false,
  //       infoStyle: {
  //         conHeight: '20px',
  //         left: '500px',
  //         top: '308px',
  //       }
  //     },
  //     {
  //       id: 'QSC',
  //       name: '清水池',
  //       lineBox: 'bottom',
  //       show: false,
  //       style: {
  //         conHeight: '80px',
  //         left: '28%',
  //         top: '5%',
  //       },
  //       lineStyle: {
  //         width: '133px',
  //         bottom: '-63px',
  //         left: '80px'
  //       },
  //       show: false,
  //       infoStyle: {
  //         conHeight: '20px',
  //         left: '580px',
  //         top: '270px',
  //       }
  //     },
  //     {
  //       id: 'DLC',
  //       name: 'D型滤池',
  //       lineBox: 'bottom',
  //       style: {
  //         conHeight: '80px',
  //         left: '39%',
  //         top: '5%',
  //       },
  //       show: false,
  //       lineStyle: {
  //         width: '113px',
  //         bottom: '-53px',
  //         left: '35px'
  //       },
  //       show: false,
  //       infoStyle: {
  //         conHeight: '20px',
  //         left: '713px',
  //         top: '240px',
  //       }
  //     },
  //     {
  //       id: 'GZJ',
  //       name: '格栅间',
  //       lineBox: 'left',
  //       style: {
  //         conHeight: '64px',
  //         right: '10%',
  //         top: '50%',
  //       },
  //       lineStyle: {
  //         width: '353px',
  //         top: '83px',
  //         left: '-353px'
  //       },
  //       show: false,
  //       infoStyle: {
  //         conHeight: '20px',
  //         left: '1000px',
  //         top: '539px',
  //       }
  //     },
  //     {
  //       id: 'WNC',
  //       name: '污泥池',
  //       lineBox: 'left',
  //       style: {
  //         conHeight: '64px',
  //         right: '10%',
  //         top: '63%',
  //       },
  //       lineStyle: {
  //         width: "180px",
  //         left: '-180px'
  //       },
  //       show: false,
  //       infoStyle: {
  //         conHeight: '20px',
  //         left: '1177px',
  //         top: '627px',
  //       }
  //     },
  //     {
  //       id: 'TJC',
  //       name: '调节池',
  //       lineBox: 'top',
  //       style: {
  //         conHeight: '110px',
  //         left: '60%',
  //         top: '84%',
  //       },
  //       lineStyle: {
  //         width: "150px",
  //         right: '80px',
  //         top: '-75px'
  //       },
  //       show: false,
  //       infoStyle: {
  //         conHeight: '20px',
  //         left: '1020px',
  //         top: '626px',
  //       }
  //     },
  //     {
  //       id: 'JDJ',
  //       name: '机电间',
  //       lineBox: 'bottom',
  //       style: {
  //         conHeight: '78px',
  //         left: '59%',
  //         top: '5%',
  //       },
  //       show: false,
  //       infoStyle: {
  //         conHeight: '20px',
  //         left: '1050px',
  //         top: '178px',
  //       }
  //     },
  //     {
  //       id: 'SHC1',
  //       name: '生化池1',
  //       lineBox: 'top',
  //       style: {
  //         conHeight: '78px',
  //         left: '24%',
  //         top: '87%',
  //       },
  //       lineStyle: {
  //         width: '150px',
  //         right: '10px',
  //         top: '-75px'
  //       },
  //       show: false,
  //       infoStyle: {
  //         conHeight: '20px',
  //         left: '487px',
  //         top: '650px',
  //       }
  //     },
  //     {
  //       id: 'SHC2',
  //       name: '生化池2',
  //       lineBox: 'top',
  //       style: {
  //         conHeight: '78px',
  //         left: '34%',
  //         top: '87%',
  //       },
  //       lineStyle: {
  //         width: '150px',
  //         right: '50px',
  //         top: '-75px'
  //       },
  //       show: false,
  //       infoStyle: {
  //         conHeight: '20px',
  //         left: '617px',
  //         top: '650px',
  //       }
  //     },
  //     {
  //       id: 'SHC3',
  //       name: '生化池3',
  //       lineBox: 'top',
  //       style: {
  //         conHeight: '78px',
  //         left: '44%',
  //         top: '87%',
  //       },
  //       lineStyle: {
  //         width: "150px",
  //         right: '80px',
  //         top: '-75px'
  //       },
  //       show: false,
  //       infoStyle: {
  //         conHeight: '20px',
  //         left: '737px',
  //         top: '650px',
  //       }
  //     },
  //   ],
  //   // 黄色区域覆盖物
  //   coverBoxData: [
  //     {
  //       id: 'SHC1',
  //       name: '生化池1',
  //       style: {
  //         left: '27.8%',
  //         top: '68%',
  //         width: '70px',
  //         height: '57px',
  //         transform: 'rotate(3deg)',
  //       }
  //     },
  //     {
  //       id: 'SHC2',
  //       name: '生化池2',
  //       style: {
  //         left: '35.4%',
  //         top: '68%',
  //         width: '70px',
  //         height: '57px',
  //         transform: 'rotateZ(2deg)',
  //       }
  //     },
  //     {
  //       id: 'SHC3',
  //       name: '生化池3',
  //       style: {
  //         left: '43.3%',
  //         top: '68%',
  //         width: '68px',
  //         height: '58px',
  //         transform: 'rotateZ(0deg)',
  //       }
  //     },
  //     {
  //       id: 'GZJ1',
  //       name: '格栅机',
  //       style: {
  //         left: '57.4%',
  //         top: '55%',
  //         width: '56px',
  //         height: '16px',
  //         transform: 'rotateZ(0deg)',
  //       }
  //     },
  //     {
  //       id: 'TJC1',
  //       name: '调节池',
  //       style: {
  //         left: '62.9%',
  //         top: '55.1%',
  //         width: '75px',
  //         height: '162px',
  //         transform: 'rotateZ(-6deg)',
  //       }
  //     },
  //     {
  //       id: 'TJC1',
  //       name: '调节池',
  //       style: {
  //         left: '57.8%',
  //         top: '61.1%',
  //         width: '92px',
  //         height: '110px',
  //         transform: 'rotateZ(-3deg)',
  //       }
  //     },
  //     {
  //       id: 'WNC1',
  //       name: '污泥池',
  //       style: {
  //         left: '67.8%',
  //         top: '55%',
  //         width: '56px',
  //         height: '168px',
  //         transform: 'rotateZ(-7deg)',
  //       }
  //     },
  //   ],
  //   pipeData: [
  //     {
  //       id: 1,
  //       style: {
  //         left: '818px',
  //         top: '637px',
  //         transform: 'rotate(-92deg)',
  //         width: '230px'

  //       },
  //       fatherStyle: {
  //         width: '230px',
  //       },
  //       num: 7
  //     },
  //     {
  //       id: 2,
  //       style: {
  //         left: '933px',
  //         top: '527px',
  //         width: '40px'
  //       },
  //       fatherStyle: {
  //         width: '40px'
  //       },
  //       num: 1
  //     },
  //     {
  //       id: 3,
  //       style: {
  //         left: '847px',
  //         top: '474px',
  //         width: '230px',
  //         height: '4px',
  //         transform: 'rotate(180deg)',
  //       },
  //       fatherStyle: {
  //         width: '230px',
  //         height: '4px'
  //       },
  //       moStyle: {
  //         height: '4px'
  //       },
  //       num: 7
  //     },
  //     {
  //       id: 4,
  //       style: {
  //         left: '707px',
  //         top: '618px',
  //         width: '286px',
  //         height: '4px',
  //         transform: 'rotate(89.8deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px'
  //       },
  //       moStyle: {
  //         height: '4px'
  //       },
  //       num: 11
  //     },
  //     {
  //       id: 5,
  //       style: {
  //         left: '475px',
  //         top: '761px',
  //         width: '377px',
  //         height: '4px',
  //         transform: 'rotate(180deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '377px',
  //       },
  //       moStyle: {
  //         height: '4px'
  //       },
  //       num: 14
  //     },
  //     {
  //       id: 6,
  //       style: {
  //         left: '460px',
  //         top: '740px',
  //         height: '4px',
  //         transform: 'rotate(-81deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '39px',
  //       },
  //       moStyle: {
  //         height: '4px'
  //       },
  //       num: 1
  //     },
  //     {
  //       id: 7,
  //       style: {
  //         left: '586px',
  //         top: '740px',
  //         height: '4px',
  //         transform: 'rotate(-83deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '39px',
  //       },
  //       moStyle: {
  //         height: '4px'
  //       },
  //       num: 1
  //     },
  //     {
  //       id: 8,
  //       style: {
  //         left: '714px',
  //         top: '740px',
  //         height: '4px',
  //         transform: 'rotate(-87deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '39px',
  //       },
  //       moStyle: {
  //         height: '4px'
  //       },
  //       num: 1
  //     },
  //     {
  //       id: 9,
  //       style: {
  //         left: '569px',
  //         top: '349px',
  //         height: '4px',
  //         transform: 'rotate(-83deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '39px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px'
  //       },
  //       num: 2
  //     },
  //     {
  //       id: 10,
  //       style: {
  //         left: '680px',
  //         top: '348px',
  //         height: '4px',
  //         transform: 'rotate(-83deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '24px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px'
  //       },
  //       num: 2
  //     },
  //     {
  //       id: 11,
  //       style: {
  //         left: '787px',
  //         top: '343px',
  //         height: '4px',
  //         transform: 'rotate(-88deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '24px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px'
  //       },
  //       num: 2
  //     },
  //     {
  //       id: 12,
  //       style: {
  //         left: '590px',
  //         top: '330px',
  //         // width: '377px',
  //         height: '4px',
  //         // transform: 'rotate(180deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '132px',
  //       },
  //       moStyle: {
  //         height: '4px'
  //       },
  //       num: 5
  //     },
  //     {
  //       id: 13,
  //       style: {
  //         left: '719px',
  //         top: '330px',
  //         // width: '377px',
  //         height: '4px',
  //         transform: 'rotate(180deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '81px',
  //       },
  //       moStyle: {
  //         height: '4px'
  //       },
  //       num: 3
  //     },
  //     {
  //       id: 14,
  //       style: {
  //         left: '698px',
  //         top: '304px',
  //         // width: '377px',
  //         height: '4px',
  //         transform: 'rotate(-90deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '48px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px'
  //       },
  //       num: 3
  //     },
  //     {
  //       id: 15,
  //       style: {
  //         left: '671px',
  //         top: '275px',
  //         // width: '377px',
  //         height: '4px',
  //         transform: 'rotate(-85deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '48px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px'
  //       },
  //       num: 3
  //     },
  //     {
  //       id: 16,
  //       style: {
  //         left: '691px',
  //         top: '293px',
  //         // width: '377px',
  //         height: '4px',
  //         transform: 'rotate(180deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '20px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px'
  //       },
  //       num: 1
  //     },
  //     {
  //       id: 17,
  //       style: {
  //         left: '555px',
  //         top: '252px',
  //         // width: '377px',
  //         height: '4px',
  //         transform: 'rotate(180deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '140px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px'
  //       },
  //       num: 9
  //     },
  //     {
  //       id: 18,
  //       style: {
  //         left: '520px',
  //         top: '282px',
  //         // width: '377px',
  //         height: '4px',
  //         transform: 'rotate(99deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '60px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px'
  //       },
  //       num: 5
  //     },
  //     {
  //       id: 18,
  //       style: {
  //         left: '544px',
  //         top: '313px',
  //         // width: '377px',
  //         height: '4px',
  //         // transform: 'rotate(99deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '20px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px'
  //       },
  //       num: 1
  //     },
  //     {
  //       id: 18,
  //       style: {
  //         left: '544px',
  //         top: '313px',
  //         // width: '377px',
  //         height: '4px',
  //         // transform: 'rotate(99deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '20px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px'
  //       },
  //       num: 1
  //     },
  //     {
  //       id: 18,
  //       style: {
  //         left: '558px',
  //         top: '329px',
  //         // width: '377px',
  //         transform: 'rotate(99deg)',
  //       },
  //       fatherStyle: {
  //         width: '23px',
  //       },
  //       moStyle: {
  //         width: '10px',
  //         marginRight: '5px'
  //       },
  //       num: 1
  //     },
  //     {
  //       id: 18,
  //       style: {
  //         left: '485px',
  //         top: '337px',
  //         // width: '377px',
  //         transform: 'rotate(180deg)',
  //       },
  //       fatherStyle: {
  //         width: '80px',
  //       },
  //       moStyle: {
  //         width: '10px',
  //         marginRight: '5px'
  //       },
  //       num: 6
  //     },
  //     {
  //       id: 181,
  //       style: {
  //         left: '585px',
  //         top: '367px',
  //         // width: '377px',
  //         height: '4px',
  //         // transform: 'rotate(99deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '40px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px',
  //         backgroundColor: '#2D99FF'
  //       },
  //       num: 3
  //     },
  //     {
  //       id: 183,
  //       style: {
  //         left: '689px',
  //         top: '367px',
  //         // width: '377px',
  //         height: '4px',
  //         // transform: 'rotate(99deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '49px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px',
  //         backgroundColor: '#2D99FF'
  //       },
  //       num: 3
  //     },
  //     {
  //       id: 182,
  //       style: {
  //         left: '805px',
  //         top: '368px',
  //         // width: '377px',
  //         height: '4px',
  //         // transform: 'rotate(99deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '40px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px',
  //         backgroundColor: '#2D99FF'
  //       },
  //       num: 3
  //     },
  //     {
  //       id: 1823,
  //       style: {
  //         left: '800px',
  //         top: '413px',
  //         // width: '377px',
  //         height: '4px',
  //         transform: 'rotate(90deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '100px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px',
  //         backgroundColor: '#2D99FF'
  //       },
  //       num: 7
  //     },
  //     {
  //       id: 1821,
  //       style: {
  //         left: '850px',
  //         top: '467px',
  //         // width: '377px',
  //         height: '4px',
  //         // transform: 'rotate(99deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '300px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px',
  //         backgroundColor: '#2D99FF'
  //       },
  //       num: 20
  //     },
  //     {
  //       id: 1123,
  //       style: {
  //         left: '1129px',
  //         top: '490px',
  //         // width: '377px',
  //         height: '4px',
  //         transform: 'rotate(81deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '40px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px',
  //         backgroundColor: '#2D99FF'
  //       },
  //       num: 3
  //     },
  //     {
  //       id: 1221,
  //       style: {
  //         left: '722px',
  //         top: '255px',
  //         // width: '377px',
  //         height: '4px',
  //         // transform: 'rotate(99deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '150px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px',
  //         backgroundColor: 'cyan'
  //       },
  //       num: 9
  //     },
  //     {
  //       id: 1123,
  //       style: {
  //         left: '643px',
  //         top: '487px',
  //         // width: '377px',
  //         height: '4px',
  //         transform: 'rotate(89deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '460px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px',
  //         backgroundColor: 'cyan'
  //       },
  //       num: 30
  //     },
  //     {
  //       id: 1321,
  //       style: {
  //         left: '879px',
  //         top: '715px',
  //         // width: '377px',
  //         height: '4px',
  //         // transform: 'rotate(99deg)',
  //       },
  //       fatherStyle: {
  //         height: '4px',
  //         width: '52px',
  //       },
  //       moStyle: {
  //         height: '4px',
  //         width: '10px',
  //         marginRight: '5px',
  //         backgroundColor: 'cyan'
  //       },
  //       num: 4
  //     },
  //   ]
  // });
  /* *********************************图层及覆盖物的位置数据 e************************************** */

  /* ********************************* 玄滩 图层及覆盖物的位置数据 b************************************** */
  const [coverAndBgImgData, setCoverAndBgImgData] = useState({
    cls: 'lx-xt',
    imgUrl: lx_xt_ProcessImg,
    stateBoxData: [
      {
        id: 'JSK',
        name: '厂站进水口',
        lineBox: 'left',
        style: {
          conHeight: '108px',
          right: '3%',
          top: '24.7%',
        },
        lineStyle: {
          width: '200px',
          left: '-200px'
        },
        show: false,
        infoStyle: {
          conHeight: '20px',
          right: '22%',
          top: '30%',
        }
      },
      {
        id: 'CSQ',
        name: '厂站出水',
        lineBox: 'left',
        style: {
          conHeight: '108px',
          right: '13%',
          top: '70%',
        },
        lineStyle: {
          width: '150px',
          left: '-150px'
        },
        show: false,
        infoStyle: {
          conHeight: '20px',
          right: '30%',
          bottom: '23%',
        }
      },
      {
        id: 'YJC',
        name: '应急池',
        lineBox: 'left',
        style: {
          conHeight: '108px',
          right: '2%',
          top: '43%',
        },
        lineStyle: {
          width: '140px',
          left: '-140px'
        },
        show: false,
        infoStyle: {
          conHeight: '20px',
          right: '22%',
          top: '51%',
        }
      },
      {
        id: 'CSC',
        name: '沉砂池',
        lineBox: 'top',
        style: {
          conHeight: '108px',
          right: '42%',
          top: '85%',
        },
        lineStyle: {
          width: '200px',
          top: '-100px',
        },
        show: false,
        infoStyle: {
          conHeight: '20px',
          right: '45%',
          bottom: '34%',
        }
      },
      {
        id: 'TJC',
        name: '调节池',
        lineBox: 'top',
        style: {
          conHeight: '108px',
          right: '32%',
          top: '85%',
        },
        lineStyle: {
          width: '300px',
          top: '-150px',
        },
        show: false,
        infoStyle: {
          conHeight: '20px',
          right: '39%',
          top: '51%',
        }
      },
      {
        id: 'YYC',
        name: '厌氧池',
        lineBox: 'right',
        style: {
          conHeight: '108px',
          left: '1%',
          top: '26%',
        },
        lineStyle: {
          width: '150px',
          right: '-150px',
        },
        show: false,
        infoStyle: {
          conHeight: '20px',
          left: '17%',
          top: '30%',
        }
      },
      {
        id: 'GZC',
        name: '格栅池',
        lineBox: 'left',
        style: {
          conHeight: '108px',
          right: '3%',
          top: '59.7%',
        },
        lineStyle: {
          width: '450px',
          left: '-450px',
        },
        show: false,
        infoStyle: {
          conHeight: '20px',
          right: '38%',
          bottom: '35%',
        }
      },
      {
        id: 'QYC1',
        name: '缺氧池1',
        lineBox: 'bottom',
        style: {
          conHeight: '108px',
          left: '13%',
          top: '1%',
        },
        lineStyle: {
          width: '120px',
          bottom: '-60px',
          left: '40px'
        },
        show: false,
        infoStyle: {
          conHeight: '20px',
          left: '18%',
          top: '22%',
        }
      },
      {
        id: 'QYC2',
        name: '缺氧池2',
        lineBox: 'bottom',
        style: {
          conHeight: '108px',
          left: '32%',
          top: '1%',
        },
        lineStyle: {
          width: '190px',
          bottom: '-95px',
          left: '10px'
        },
        show: false,
        infoStyle: {
          conHeight: '20px',
          left: '35%',
          top: '33%',
        }
      },
      {
        id: 'QYC3',
        name: '缺氧池3',
        lineBox: 'bottom',
        style: {
          conHeight: '108px',
          left: '42%',
          top: '1%',
        },
        lineStyle: {
          width: '190px',
          bottom: '-95px',
          left: '10px'
        },
        show: false,
        infoStyle: {
          conHeight: '20px',
          left: '42%',
          top: '33%',
        }
      },
      {
        id: 'HYC1',
        name: '好氧池1',
        lineBox: 'top',
        style: {
          conHeight: '108px',
          left: '29%',
          top: '85%',
        },
        lineStyle: {
          width: '320px',
          top: '-160px',
          right: '-50px'
        },
        show: false,
        infoStyle: {
          conHeight: '20px',
          left: '34%',
          bottom: '44%',
        }
      },
      {
        id: 'HYC2',
        name: '好氧池2',
        lineBox: 'top',
        style: {
          conHeight: '108px',
          left: '39%',
          top: '85%',
        },
        lineStyle: {
          width: '320px',
          top: '-160px',
          right: '-50px'
        },
        show: false,
        infoStyle: {
          conHeight: '20px',
          left: '41%',
          bottom: '44%',
        }
      },
      {
        id: 'ZWXXDQ',
        name: '紫外线消毒渠',
        lineBox: 'right',
        style: {
          conHeight: '108px',
          left: '69%',
          top: '85%',
        },
        lineStyle: {
          width: '150px',
          top: '-50px',
          left: '-90px',
          transform: 'rotate(-130deg)',
        },
        show: false,
        infoStyle: {
          conHeight: '20px',
          right: '35%',
          bottom: '25%',
        }
      },
      {
        id: 'HXCLC',
        name: '化学除磷池',
        lineBox: 'bottom',
        style: {
          conHeight: '108px',
          left: '62%',
          top: '1%',
        },
        lineStyle: {
          width: '200px',
          bottom: '-100px',
          left: '-60px'
        },
        show: false,
        infoStyle: {
          conHeight: '20px',
          right: '40%',
          top: '30%',
        }
      },
      {
        id: 'GFJF',
        name: '鼓风机房',
        lineBox: 'bottom',
        style: {
          conHeight: '108px',
          left: '22.6%',
          top: '1%',
        },
        lineStyle: {
          width: '200px',
          bottom: '-100px',
          left: '0px'
        },
        show: false,
        infoStyle: {
          conHeight: '20px',
          left: '27%',
          top: '30%',
        }
      },
      {
        id: 'MBR',
        name: 'MBR膜池',
        lineBox: 'bottom',
        style: {
          conHeight: '108px',
          left: '52%',
          top: '1%',
        },
        lineStyle: {
          width: '400px',
          bottom: ' -150px',
          left: '-200px',
          transform: 'rotate(120deg)'
        },
        show: false,
        infoStyle: {
          conHeight: '20px',
          left: '43%',
          top: '43%',
        }
      },
    ],
    // 黄色区域覆盖物
    coverBoxData: [
    ],
    pipeData: [
      {
        id: 1,
        style: {
          left: '69%',
          top: '36.5%',
          // transform: 'rotateY(180deg)',
        },
        fatherStyle: {
          width: '60px',
        },
        num: 2
      },
      {
        id: 2,
        style: {
          left: '67.8%',
          top: '38.7%',
          transform: 'rotate(-97deg)',
        },
        fatherStyle: {
          width: '56px',
        },
        num: 2
      },
      {
        id: 3,
        style: {
          left: '64.8%',
          top: '41%',
          // transform: 'rotateY(180deg)',
        },
        fatherStyle: {
          width: '80px',
        },
        num: 3
      },
      {
        id: 4,
        style: {
          left: '55.8%',
          top: '40.2%',
          transform: 'rotateY(180deg)',
        },
        small: true,
        fatherStyle: {
          width: '120px',
        },
        num: 4
      },
      {
        id: 5,
        style: {
          left: '53.5%',
          top: '45%',
          // transform: 'rotateY(180deg)',
        },
        small: true,
        fatherStyle: {
          width: '330px',
        },
        num: 10
      },
      {
        id: 7,
        style: {
          left: '50.8%',
          top: '37.9%',
          // transform: 'rotateY(180deg)',
        },
        small: true,
        fatherStyle: {
          width: '90px',
        },
        num: 3
      },
      {
        id: 6,
        style: {
          left: '49.6%',
          top: '32.5%',
          // transform: 'rotate(180deg)',
        },
        small: true,
        fatherStyle: {
          width: '70px',
        },
        num: 2
      },
      {
        id: 61,
        style: {
          left: '44.5%',
          top: '38.5%',
          transform: 'rotate(-90deg)',
        },
        small: true,
        fatherStyle: {
          width: '180px',
        },
        num: 5
      },
      {
        id: 62,
        style: {
          left: '45.76%',
          top: '45.5%',
          transform: 'rotate(-91deg)',
        },
        small: true,
        fatherStyle: {
          width: '170px',
        },
        num: 5
      },
      {
        id: 7,
        style: {
          left: '66.4%',
          top: '57.5%',
          transform: 'rotateY(180deg)',
        },
        small: true,
        fatherStyle: {
          width: '110px',
        },
        num: 4
      },
      {
        id: 8,
        style: {
          left: '43.8%',
          top: '62%',
          transform: 'rotate(-91deg) rotateY(180deg)',
        },
        // small: true,
        fatherStyle: {
          width: '300px',
        },
        num: 12
      },
      {
        id: 9,
        style: {
          left: '10.35%',
          top: '76%',
          transform: 'rotateY(180deg)',
        },
        // small: true,
        fatherStyle: {
          width: '740px',
        },
        num: 30
      },
      {
        id: 10,
        style: {
          left: '-3.8%',
          top: '49%',
          transform: 'rotate(100deg) rotateY(180deg)',
        },
        // small: true,
        fatherStyle: {
          width: '600px',
        },
        num: 25
      },
      {
        id: 11,
        style: {
          left: '17.5%',
          top: '32.5%',
          transform: 'rotate(98deg) rotateY(180deg)',
        },
        // small: true,
        fatherStyle: {
          width: '230px',
        },
        num: 7
      },
      {
        id: 12,
        style: {
          left: '21%',
          top: '42.3%',
          // transform: 'rotate(98deg)',
        },
        small: true,
        fatherStyle: {
          width: '160px',
        },
        num: 4
      },
      {
        id: 13,
        style: {
          left: '21.8%',
          top: '44%',
          // transform: 'rotate(98deg)',
        },
        small: true,
        fatherStyle: {
          width: '140px',
        },
        num: 4
      },
      {
        id: 14,
        style: {
          left: '15.8%',
          top: '40.5%',
          transform: 'rotate(98deg)',
        },
        small: true,
        fatherStyle: {
          width: '60px',
        },
        num: 2
      },
      {
        id: 15,
        style: {
          left: '19.7%',
          top: '40.5%',
          transform: 'rotate(98deg)',
        },
        small: true,
        fatherStyle: {
          width: '40px',
        },
        num: 1
      },
      {
        id: 16,
        style: {
          left: '23%',
          top: '43%',
          transform: 'rotateY(180deg)',
        },
        // small: true,
        fatherStyle: {
          width: '130px',
        },
        num: 5
      },
      {
        id: 17,
        style: {
          left: '24.1%',
          top: '52.5%',
          transform: 'rotate(95deg)',
        },
        small: true,
        fatherStyle: {
          width: '180px',
        },
        num: 5
      },
      {
        id: 18,
        style: {
          left: '27.4%',
          top: '37.4%',
          transform: 'rotate(-84deg)',
        },
        small: true,
        fatherStyle: {
          width: '100px',
        },
        num: 3
      },
      {
        id: 19,
        style: {
          left: '30.5%',
          top: '32.6%',
          // transform: 'rotate(-84deg)',
        },
        small: true,
        fatherStyle: {
          width: '50px',
        },
        num: 1
      },
      {
        id: 20,
        style: {
          left: '28.7%',
          top: '61%',
          // transform: 'rotate(-84deg)',
        },
        small: true,
        fatherStyle: {
          width: '50px',
        },
        num: 1
      },
      { // 改变颜色
        id: 21,
        style: {
          left: '27.8%',
          top: '31.8%',
          // transform: 'rotate(-84deg)',
        },
        small: true,
        fatherStyle: {
          width: '40px',
          background: '#ccc'
        },
        moStyle: {
          background: '#F5F94B'
        },
        num: 1
      },
      { // 改变颜色
        id: 22,
        style: {
          left: '27%',
          top: '44.6%',
          // transform: 'rotate(-84deg)',
        },
        small: true,
        fatherStyle: {
          width: '40px',
          background: '#ccc'
        },
        moStyle: {
          background: '#F5F94B'
        },
        num: 1
      },
      { // 改变颜色
        id: 23,
        style: {
          left: '22.6%',
          top: '42.6%',
          transform: 'rotate(96deg)',
        },
        small: true,
        fatherStyle: {
          width: '240px',
          background: '#ccc'
        },
        moStyle: {
          background: '#F5F94B'
        },
        num: 8
      },
      { // 改变颜色
        id: 24,
        style: {
          left: '28.6%',
          top: '53%',
          transform: 'rotate(-15deg)',
        },
        small: true,
        fatherStyle: {
          width: '60px',
          background: '#ccc'
        },
        moStyle: {
          background: '#F5F94B'
        },
        num: 2
      },
      { // 改变颜色
        id: 25,
        style: {
          left: '32%',
          top: '52.4%',
          // transform: 'rotate(-15deg)',
        },
        small: true,
        fatherStyle: {
          width: '285px',
          background: '#ccc'
        },
        moStyle: {
          background: '#F5F94B'
        },
        num: 10
      },
      { // 改变颜色
        id: 26,
        style: {
          left: '29.6%',
          top: '37.8%',
          transform: 'rotate(-15deg)',
        },
        small: true,
        fatherStyle: {
          width: '60px',
          background: '#ccc'
        },
        moStyle: {
          background: '#F5F94B'
        },
        num: 2
      },
      { // 改变颜色
        id: 27,
        style: {
          left: '32.8%',
          top: '37%',
          // transform: 'rotate(-15deg)',
        },
        small: true,
        fatherStyle: {
          width: '270px',
          background: '#ccc'
        },
        moStyle: {
          background: '#F5F94B'
        },
        num: 10
      },
      { // 改变颜色
        id: 26,
        style: {
          left: '29.4%',
          top: '46%',
          // transform: 'rotate(-15deg)',
        },
        small: true,
        fatherStyle: {
          width: '50px',
          background: '#ccc'
        },
        moStyle: {
          background: '#F5F94B'
        },
        num: 2
      },
    ]
  });
  /* *********************************图层及覆盖物的位置数据 e************************************** */

  // 工艺流程图点位信息设置
  const setProcessImgPosFn = () => {
    if (markers.length > 0) {
      let selStationsInfo = null;
      markers.map(mm => {
        if (mm.id == id) {
          selStationsInfo = mm;
        }
      })
      switch (selStationsInfo.aliasName || selStationsInfo.name) {
        case '玄滩':
          // setCoverAndBgImgData()
          break;

        default:
          setCoverAndBgImgData({
            cls: '',
            imgUrl: xsProcessImg,
            stateBoxData: [
              {
                id: 'CSQ',
                name: '出水口',
                lineBox: 'right',
                style: {
                  conHeight: '108px',
                  left: '10%',
                  top: '28.5%',
                }
              },
              {
                id: 'QSC',
                name: '清水池',
                lineBox: 'bottom',
                style: {
                  conHeight: '80px',
                  left: '31%',
                  top: '15%',
                }
              },
              {
                id: 'DLC',
                name: 'D型滤池',
                lineBox: 'bottom',
                style: {
                  conHeight: '80px',
                  left: '39%',
                  top: '12%',
                }
              },
              {
                id: 'GZJ',
                name: '格栅间',
                lineBox: 'bottom',
                style: {
                  conHeight: '64px',
                  left: '55%',
                  top: '41%',
                }
              },
              {
                id: 'WNC',
                name: '污泥池',
                lineBox: 'bottom',
                style: {
                  conHeight: '64px',
                  left: '65%',
                  top: '45%',
                }
              },
              {
                id: 'TJC',
                name: '调节池',
                lineBox: 'left',
                style: {
                  conHeight: '110px',
                  left: '65.2%',
                  top: '62.5%',
                }
              },
              {
                id: 'JDJ',
                name: '机电间',
                lineBox: 'bottom',
                style: {
                  conHeight: '78px',
                  left: '59%',
                  top: '12%',
                }
              },
              {
                id: 'SHC1',
                name: '生化池1',
                lineBox: 'top',
                style: {
                  conHeight: '78px',
                  left: '25.5%',
                  top: '87%',
                }
              },
              {
                id: 'SHC2',
                name: '生化池2',
                lineBox: 'top',
                style: {
                  conHeight: '78px',
                  left: '34%',
                  top: '87%',

                }
              },
              {
                id: 'SHC3',
                name: '生化池3',
                lineBox: 'top',
                style: {
                  conHeight: '78px',
                  left: '42.7%',
                  top: '87%',

                }
              },
            ],
            // 黄色区域覆盖物
            coverBoxData: [
              {
                id: 'SHC1',
                name: '生化池1',
                style: {
                  left: '27.8%',
                  top: '68%',
                  width: '70px',
                  height: '57px',
                  transform: 'rotate(3deg)',
                }
              },
              {
                id: 'SHC2',
                name: '生化池2',
                style: {
                  left: '35.4%',
                  top: '68%',
                  width: '70px',
                  height: '57px',
                  transform: 'rotateZ(2deg)',
                }
              },
              {
                id: 'SHC3',
                name: '生化池3',
                style: {
                  left: '43.3%',
                  top: '68%',
                  width: '68px',
                  height: '58px',
                  transform: 'rotateZ(0deg)',
                }
              },
              {
                id: 'GZJ1',
                name: '格栅机',
                style: {
                  left: '57.4%',
                  top: '55%',
                  width: '56px',
                  height: '16px',
                  transform: 'rotateZ(0deg)',
                }
              },
              {
                id: 'TJC1',
                name: '调节池',
                style: {
                  left: '62.9%',
                  top: '55.1%',
                  width: '75px',
                  height: '162px',
                  transform: 'rotateZ(-6deg)',
                }
              },
              {
                id: 'TJC1',
                name: '调节池',
                style: {
                  left: '57.8%',
                  top: '61.1%',
                  width: '92px',
                  height: '110px',
                  transform: 'rotateZ(-3deg)',
                }
              },
              {
                id: 'WNC1',
                name: '污泥池',
                style: {
                  left: '67.8%',
                  top: '55%',
                  width: '56px',
                  height: '168px',
                  transform: 'rotateZ(-7deg)',
                }
              },
            ]
          })
          break;
      }
    }
  };

  useEffect(() => {
    let timer = null
    if (id) {
      setProcessImgPosFn()
      timer = setInterval(() => {
        getMarkersDetail(id)
      }, 5000)
    }
    return () => {
      timer && clearInterval(timer)
    };
  }, [id, markers]);

  /**
   * GIS站点列表查询
   * @param {*} {}
   * @returns
   */
  const getMarkersList = () => {
    stationgisApi.selectGisStationList(userInfo.stationIds ? userInfo.stationIds.split(',') : []).then(
      (res) => {
        if (res.status == 0 && res.data.length > 0) {
          if (!params.id) {
            let isLuXianXT = false;
            res.data.map(mm => {
              // console.log(mm.name, mm.aliasName)
              if (mm.aliasName == '玄滩') {
                isLuXianXT = true;
                setId(mm.id.toString());
                setName(mm.name);
                getMarkersDetail(mm.id);
              }
            });
            if (!isLuXianXT) {
              setId(res.data[0].id.toString());
              setName(res.data[0].name);
              getMarkersDetail(res.data[0].id);
            }
          } else {
            setId(params.id);
            setName(params.name);
            getMarkersDetail(params.id);
          }
          setMarkers(() => {
            return [...res.data];
          });
        }
      }
    );
  };

  // 切换厂站
  const handleChange = (val) => {
    setId(val.toString());
    markers.map((item) => {
      if (item.id == val) {
        setName(item.aliasName || item.name);
      }
    })
    getMarkersDetail(val);
  };

  useEffect(() => {
    getMarkersList();
  }, [])

  /* ********************************* 参数设置相关 begin ************************************** */
  // 参数设置弹窗loading状态切换
  const handleSetLoding = (val) => {
    setLoading(val);
  };

  // 查询站点下所有参数配置信息。flag:是否是更新信息后取数据，更新信息后，选中工艺单元不变
  const findCommandsByParams = (flag) => {
    stationflowchart.findParSetByStationId({ stationId: id }).then((res) => {
      if (res.status == 0) {
        setCommandsAll(() => {
          return [...res.data];
        });
        if (res.data.length > 0) {
          if (!flag) {
            setActiveIdx(0);
          }
          setRightDatas(() => {
            return [...res.data[activeIdx].displayVOList];
          });
        } else {
          setRightDatas([])
        }
      }
    });
  };

  // 所有工艺单元
  const [allGYDY, setallGYDY] = useState([]);
  /**
   * 获取工艺单元详情
   * @param {*} {}
   * @returns
   */
  const getMarkersDetail = (id) => {
    stationflowchart.findDisplayByStationId({ stationId: id }).then((res) => {
      // console.log(infoJson, 'xxxxxx')
      // let res = infoJson
      if (res.status == 0) {
        setjskLLLArr([])
        const obj = {};
        let CSSSLL = 0;  //出水瞬时流量
        let CSLJLL = 0; //出水累计流量
        let JSSSLL = 0; //进水瞬时流量
        let JSLJLL = 0; //进水累计流量
        res.data.forEach((item) => {
          obj[item.processunitValue] = matchZGJData(item.displayVOList, item)
          switch (item.processunitValue) {
            case "CSQ": //厂站出水口
              item.displayVOList.map(item => {
                if ((item.gatherDevPointValue).includes("_SSLL")) {
                  CSSSLL += item.val
                }
                if ((item.gatherDevPointValue).includes("_LJLL")) {
                  CSLJLL += item.val
                }
              })
              break;
            case "JSK": //厂站进水口
              item.displayVOList.map((item, index) => {
                if ((item.gatherDevPointValue).includes("_SSLL")) {
                  JSSSLL += item.val
                }
                if ((item.gatherDevPointValue).includes("_LJLL")) {
                  JSLJLL += item.val
                }
              })
              // 进水口流量计数据集合
              let data = [];
              obj.JSK.map((mm, idx) => {
                if ((mm.gatherDevPointValue).includes("_SSLL") || (mm.gatherDevPointValue).includes("_LJLL")) {
                  let obj = {
                    deviceName: mm.deviceName,
                  };
                  item.displayVOList.map((item, index) => {
                    if (item.devId == mm.devId && ((item.gatherDevPointValue).includes("_SSLL") || (item.gatherDevPointValue).includes("_LJLL"))) {
                      if ((item.gatherDevPointValue).includes("_SSLL")) {
                        obj.ssll = item.val;
                      }
                      if ((item.gatherDevPointValue).includes("_LJLL")) {
                        obj.ljll = item.val;
                      }
                    }
                  })
                  data.push(obj)
                }
              })
              setjskLLLArr(data)
              break;
            default:
              break;
          }
        });
        setallGYDY(res.data);
        setDetailInfo(obj);
        // 底部展示数据
        CSSSLL = CSSSLL.toFixed(2);
        CSLJLL = CSLJLL.toFixed(2);
        JSSSLL = JSSSLL.toFixed(2);
        JSLJLL = JSLJLL.toFixed(2);
        let showDataTemp = { CSSSLL, CSLJLL, JSSSLL, JSLJLL }
        setAllShowData({
          ...showData,
          ...showDataTemp
        })
      }
    });
  };

  const matchZGJData = (myResIdArr, data) => {
    let map = {};
    let resDest = [];
    //故障设备id集合
    let isGZArr = [];
    // 停止设备id集合
    let isTZArr = [];
    let devIds = myResIdArr.map(mm => mm.devId)
    devIds = [...new Set(devIds)];
    devIds.map((nn) => {
      myResIdArr.map((mm) => {
        if (nn == mm.devId) {
          // 故障
          if ((mm.gatherDevPointValue).split("_")[2] == 'ZG' && mm.val == 1) {
            isGZArr.push(nn)
          }
          // 停止
          if ((mm.gatherDevPointValue).split("_")[2] == 'QT' && mm.val == 0) {
            isTZArr.push(nn)
          }
        }
      })
    })
    for (let i = 0; i < myResIdArr.length; i++) {
      let ai = myResIdArr[i];
      if (!map[ai.deviceName]) {
        //此处插入的数据结构可根据需求，自我定制
        let statusKey = (ai.gatherDevPointValue).split("_")

        if (statusKey[3] == "T") {
          resDest.push({
            ...ai,
            dataType: statusKey[3],
            [`${statusKey[2]}`]: ai.val,
            processunitId: data.processunitId,
            processunitName: data.processunitName,
            processunitValue: data.processunitValue,
          });
        } else {
          resDest.push({
            ...ai,
            type: statusKey[3],
            status: ai.type,
            processunitId: data.processunitId,
            processunitName: data.processunitName,
            processunitValue: data.processunitValue,
          });
        }
        map[ai.deviceName] = ai;
      } else {
        for (let j = 0; j < resDest.length; j++) {
          let dj = resDest[j];

          if (dj.deviceName == ai.deviceName) {
            let statusKey = (ai.gatherDevPointValue).split("_")

            if (statusKey[3] == "T") {
              dj = {
                ...dj,
                dataType: statusKey[3],
                [`${statusKey[2]}`]: ai.val
              };
            } else {
              dj = {
                ...dj,
                dataType: statusKey[3],
                status: ai.type
              }
            }

            dj = {
              ...dj,
              processunitId: data.processunitId,
              processunitName: data.processunitName,
              processunitValue: data.processunitValue,
            }
            resDest[j] = dj

            break;
          }
        }
      }
    }
    resDest.map((mm) => {
      mm.isGZDev = false;
      mm.isTZDev = false;
      mm.alarm = data.alarm; // 工艺单元是否含有故障设备，0无，1有
      if (isGZArr.indexOf(mm.devId) > -1) {
        mm.isGZDev = true;
      }
      if (isTZArr.indexOf(mm.devId) > -1) {
        mm.isTZDev = true;
      }
    })
    return resDest //resDest[i].totalCount即为resDest[i].typeName该大类下的数据list，遍历渲染即可
  }

  // 匹配字体图标
  const getIcon = (item) => {
    let iconStr = "";
    switch (item.processunitName) {
      case "调节池":
        iconStr = "iconicon_gongyidanyuan_tiaojiechi_32";
        break;
      case "污泥池":
        iconStr = "iconicon_gongyidanyuan_wunichi_32";
        break;
      case "格栅":
        iconStr = "iconicon_gongyidanyuan_gezhaqu_32";
        break;
      case "加药间":
        iconStr = "iconicon_gongyidanyuan_jiayaojian_32";
        break;
      case "机电间1":
      case "机电间2":
      case "机电间3":
        iconStr = "iconicon_gongyidanyuan_jidianjian_32";
        break;
      case "厌氧池":
        iconStr = "iconicon_gongyidanyuan_yanyangchi_32";
        break;
      case "好氧池":
        iconStr = "iconicon_gongyidanyuan_haoyangchi_32";
        break;
      case "兼氧池":
        iconStr = "iconicon_gongyidanyuan_jianyangchi_32";
        break;
      case "沉淀池":
        iconStr = "iconicon_gongyidanyuan_chendianchi_32";
        break;
      case "清水池":
        iconStr = "iconicon_gongyidanyuan_qingshuichi_32";
        break;
      case "D型滤池":
        iconStr = "iconicon_gongyidanyuan_Dxinglvchi_32";
        break;
      default:
        iconStr = "iconicon_gongyidanyuan_Dxinglvchi_32";
        break;
    }
    return iconStr;
  };

  // 渲染所有参数左侧信息
  const renderAllConfigLeft = (item, index) => {
    return (
      <div
        onClick={() => {
          setActiveIdx(index);
          setRightDatas(() => {
            return [...commandsAll[index].displayVOList];
          });
        }}
        className={classnames({
          "config-left-item": true,
          "active-config": activeIdx == index
        })}
        key={'dd' + index}
      >
        <div>
          <MyIcon className="config-icon" type={getIcon(item)} />
          <div>{item.processunitName}</div>
        </div>
        {activeIdx == index && <span className="techProcess-rotate270"><MyIcon type="iconxiala" /></span>}
      </div>
    );
  };

  // 刷新右侧详细参数信息列表
  const refreshCommandsAll = () => {
    setCommandsAll(() => {
      return [...commandsAll];
    });
  };
  // 右侧输入框改变时
  const handleInputChange = (value, item) => {
    item.val = value;
    refreshCommandsAll();
  };
  // 右侧输入框失去焦点时提交修改
  const handleInputBlur = (item) => {
    item.disabled = false;
    let data = {
      gatherDevPointId: item.gatherDevPointId,
      processunitId: commandsAll[activeIdx].processunitId,
      stationId: id,
      val: item.val * 1
    };
    handleSetLoding(true);
    stationflowchart.update(data).then((res) => {
      handleSetLoding(false);
      findCommandsByParams(true);
      if (res.status == 0) {
        message.success("修改成功");
      }
    });

  };

  /*
   * @function 渲染右侧详细参数信息
   * item.devTypeAttrValue 后缀包含_C时，为控制开关模块。参数配置页面不做显示
   */
  const renderAllConfigRight = (item, index) => {
    let four = item.gatherDevPointValue.split('_')[3];
    if (four != 'C') {
      let three = item.gatherDevPointValue.split('_')[2];
      return (
        <div key={'c' + index} className="config-right-item">
          <div className="config-right-title">
            {item.deviceName}
            <span className={classnames({
              'status-tip': true,
              red: three == 'GZ' && item.val == 1
            })}>{three == 'GZ' && item.val == 1 ? '异常' : '正常'}</span>
          </div>
          <div className="config-right-main">
            <span>{item.gatherDevPointName}</span>
            <div>
              <Input
                disabled={!item.disabled}
                className="config-right-input"
                value={item.val}
                suffix={item.gatherDevPoiParUnit}
                ref={(ref) => {
                  inputRef[index] = ref;
                }}
                onChange={({ target: { value } }) => {
                  handleInputChange(value, item);
                }}
                onBlur={() => {
                  handleInputBlur(item);
                }}
              />
              <MyIcon
                onClick={() => {
                  item.disabled = true;
                  if (inputRef[index]) {
                    setTimeout(() => {
                      inputRef[index].focus();
                    }, 300);
                  }
                  refreshCommandsAll();
                }}
                className="config-icon config-right-icon"
                type="iconxiugai"
                style={{ marginLeft: "16px", cursor: "pointer" }}
              />
            </div>
          </div>
        </div>
      );
    }
  };

  /*
    @function 设置弹框宽度
    @小米要求 大于等于三个时一排显示三个；小于三个一排显示两个
  */
  const getModalWidth = (len) => {
    // let width = 592;
    // if (len >= 3) {
    //   width = 924;
    // } else if (len < 3) {
    //   width = 624;
    // }
    let width = 760;
    setModalWidth(width);
  };
  /* ********************************* 参数设置相关 end ************************************** */


  // 点击工艺单元时，弹框显示
  const setConfigVisibleItem = (name, key) => {
    console.log(name, key, 'ddd')
    console.log(detailInfo, 'detailInfo')
    console.log(allGYDY, 'allGYDY')
    let cacheId = 0;
    if (detailInfo[key] && detailInfo[key].length == 0) {
      allGYDY.map(mm => {
        if (mm.processunitValue == key) {
          cacheId = mm.processunitId
        }
      });
    }
    // 厂站出水口和厂站进水口不展示详情弹窗
    if (detailInfo[key] && (
      (detailInfo[key].length > 0 &&
        detailInfo[key][0].processunitValue != 'CSQ' &&
        detailInfo[key][0].processunitValue != 'JSK')
      || detailInfo[key].length == 0)) {
      let processunitId = cacheId ? cacheId : detailInfo[key][0].processunitId;
      setConfigVisible(true);
      setCurrentConfig(processunitId);
      setTitle(name);
    }
  };

  /* *********************************视频相关开始************************************** */

  /* *********************************视频相关结束************************************** */

  return (
    <div className={"baseContent techProcess " + coverAndBgImgData.cls}>
      <div style={{ width: "100%", height: "100%", position: "relative" }}>
        <div className="img-container">
          <img src={coverAndBgImgData.imgUrl} className="tech-process-img" />
          {/* 主体状态内容信息 */}
          <StateBox
            handleVisble={setConfigVisibleItem}
            positionData={coverAndBgImgData}
            detailInfo={detailInfo}
            allGYDY={allGYDY}
          />

        </div>
      </div>

      {/* 顶部操作栏信息 */}
      <div className="operate-box">
        <div className="left">
          <Select
            value={id}
            className="operate-select"
            onChange={handleChange}
          >
            {markers &&
              markers.length > 0 &&
              markers.map((item, index) => {
                return (
                  <Option key={index} value={item.id.toString()}>
                    {item.aliasName || item.name}
                  </Option>
                );
              })}
          </Select>
        </div>
        <div className="right">
          <Button
            className="operate-btn"
            style={{ marginRight: "16px" }}
            type="primary"
            onClick={() => {
              setConfigVisible(true);
              setModalWidth(592);
              findCommandsByParams();
              setTitle("参数设置");
            }}
            icon={<MyIcon type="iconcanshushezhi" />}
          >
            参数设置
          </Button>
          <Button
            className="operate-btn"
            onClick={() => {
              setVisible(true);
            }}
            type="primary"
            icon={<MyIcon type="iconshexiangtou2" />}
          >
            摄像头
          </Button>
        </div>
      </div>

      {/* 右侧进出水口数据展示区域 begin */}
      <div className="inOutWater-box">
        <Collapse defaultActiveKey={['1', '2']}>
          <Collapse.Panel header="进水口" showArrow={true} key="1">
            <div className="item">
              <div className="tit">
                <i className="green iconfont iconleijiliuliang"></i>
                <span className="name">累计流量</span>
                <span>m³</span>
              </div>
              <div className="val">{showData.JSLJLL}</div>
              <div className="tit">
                <i className="yellow iconfont iconshunshiliuliang"></i>
                <span className="name">瞬时流量</span>
                <span>m³/h</span>
              </div>
              <div className="val">{showData.JSSSLL}</div>
            </div>
            {
              jskLLLArr.map((item, idx) => <div className="item" key={'jsk' + idx}>
                <div className="tit-name">{item.deviceName}</div>
                <div className="tit">
                  <i className="green iconfont iconleijiliuliang"></i>
                  <span className="name">累计流量</span>
                  <span><b>{item.ljll}</b>m³</span>
                </div>
                <div className="tit">
                  <i className="yellow iconfont iconshunshiliuliang"></i>
                  <span className="name">瞬时流量</span>
                  <span><b>{item.ssll}</b>m³/h</span>
                </div>
              </div>)
            }
          </Collapse.Panel>
          <Collapse.Panel header="出水口" showArrow={true} key="2">
            <div className="item">
              <div className="tit">
                <i className="green iconfont iconleijiliuliang"></i>
                <span className="name">累计流量</span>
                <span>m³</span>
              </div>
              <div className="val">{showData.CSLJLL}</div>
              <div className="tit">
                <i className="yellow iconfont iconshunshiliuliang"></i>
                <span className="name">瞬时流量</span>
                <span>m³/h</span>
              </div>
              <div className="val">{showData.CSSSLL}</div>
            </div>
          </Collapse.Panel>
        </Collapse>
        {/* <div>
          <img src={require(`./img/567.gif`)} alt="" />
        </div> */}

      </div>
      {/* 右侧进出水口数据展示区域 end */}

      {/* 参数配置弹框 b */}
      <Modal
        title={title}
        width={modalWidth}
        className={classnames({
          "config-modal": true,
          'device-modal': title !== "参数设置"
        })
        }
        destroyOnClose
        open={configVisible}
        onOk={() => setConfigVisible(false)}
        onCancel={() => {
          setActiveIdx(0);
          setConfigVisible(false);
        }}
        maskClosable={!loading && title == "参数设置"}
        keyboard={false}
      >
        <Spin spinning={loading} tip="正在下发指令,请稍等...">
          {title == "参数设置" && (
            <div className="all-config">
              {/* stationflowchart.findParSetByStationId({ stationId: id }).then((res) => { */}
              <div className="all-config-left">
                {commandsAll &&
                  commandsAll.length > 0 &&
                  commandsAll.map((item, index) => {
                    return renderAllConfigLeft(item, index);
                  })}
              </div>
              <div className="all-config-right">
                {commandsAll.length == 0 && <div style={{ color: '#999', 'textIndent': '98px' }}>- 暂无数据 -</div>}
                {rightDatas &&
                  rightDatas.length > 0 &&
                  rightDatas.map((item, index) => {
                    if (item) {
                      return renderAllConfigRight(item, index);
                    }
                  })}
              </div>
            </div>
          )}
          {title !== "参数设置" && (
            <ConfigItemEdit
              getWidth={getModalWidth}
              detailInfo={detailInfo[currentConfig]}
              id={id}
              currentConfig={currentConfig}
              handleSetLoding={handleSetLoding}
            />
          )}
        </Spin>
      </Modal>
      {/* 参数配置弹框 e */}

      {/* 视频相关弹框 b */}
      {
        visible ? <VideoModal setVisible={setVisible} id={id} name={name} /> : null
      }
      {/* 视频相关弹框 e */}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(Pages);
